import Palette from '../../common/Color/Palette';

export default Palette;
